import React, { useEffect, useState } from 'react'
import { IconButton } from '@st-operations/uikit/src/v2'
import Form from '_components/form/Form'

import './styles.scss'

const CustomField = (props) => {
  const [item, setItem] = useState({})
  const { onAdd, onRemove, isRemove, field, fields, schema } = props

  useEffect(() => {
    if (field) {
      setItem(field)
    }
  }, [field])

  const onChange = (value, name) => {
    const updatedItem = {
      ...item,
      [name]: value?.value || value,
    }
    setItem(updatedItem)
  }

  const addItem = () => {
    for (const field of fields) {
      if (!item[field.name]) {
        return toast.error('Please fill all fields')
      }
    }
    onAdd(item)
    setItem({})
  }

  const removeItem = () => {
    onRemove(item)
    setItem({})
  }

  return (
    <div className="destination-custom-field-container">
      <Form
        disabled={isRemove}
        fields={
          fields?.length
            ? fields.map((field) => {
                return {
                  ...field,
                  disabled: false,
                }
              })
            : []
        }
        schema={schema}
        item={item}
        onChange={onChange}
        className="destination-custom-field"
      />
      <If condition={isRemove}>
        <IconButton
          className="custom-field-icon-btn"
          onClick={removeItem}
          iconProps={{ icon: 'minus', type: 'fill', width: '18px' }}
        />
      </If>
      <If condition={!isRemove}>
        <IconButton
          className="custom-field-icon-btn"
          onClick={addItem}
          iconProps={{ icon: 'add', type: 'fill', width: '18px' }}
        />
      </If>
    </div>
  )
}

export default CustomField
